export default "__VITE_ASSET__DGxq_P_$__"